import { gql } from '@apollo/client';

import client from '../../../../../core/services/graphql';

export const searchUsers = async (search, projectId) => {
  const query = gql`
    query searchNewTesters($projectId: ID!, $search: String!) {
      searchNewTesters(search: $search, projectId: $projectId) {
        id
        profile {
          id
          firstName
          lastName
          linkedinFields {
            id
          }
        }
     }
    }
  `;

  const { data } = await client.getClient().query({
    query,
    variables: { projectId, search },
  });

  return data;
};

export const inviteTester = async (userId, projectId) => {
  const query = gql`
    mutation InviteTesters($userIds: [ID!]!, $projectId: ID!) {
      inviteTesters(userIds: $userIds, projectId: $projectId) {
        testers {
          id
        }
      }
    }
  `;

  const { data } = await client.getClient().mutate({
    mutation: query,
    variables: { projectId, userIds: [userId] },
  });

  return data;
};

export const CHANGE_PROJECT_STATUS = gql`
  mutation changeProjectStatus($projectId: ID!, $status: ProjectStatusEnum!) {
    changeProjectStatus(projectId: $projectId, status: $status) {
      project {
        id
        status
      }
    }
  }
`;
